import { upsertTaskTemplates } from '@dispatch/shared/services';
import { TaskTemplatesPostBody } from '@dispatch/shared/types';
import { useMutation, useQueryClient } from 'react-query';

export const useUpsertTaskTemplate = (
  onSuccess: () => void,
  tenantId?: string,
  taskTemplateId?: string,
  externalId?: string
) => {
  const client = useQueryClient();
  const { mutate, error, status } = useMutation(
    ['upsert-taskTemplate'],
    async (data: Partial<TaskTemplatesPostBody>) =>
      upsertTaskTemplates(taskTemplateId, data, tenantId),
    {
      onSuccess,
      onSettled: () => {
        if (taskTemplateId) {
          client.invalidateQueries(['task-template', externalId]);
          client.invalidateQueries('task-template');
        }
      },
    }
  );

  return {
    upsertTaskTemplate: mutate,
    error,
    upsertTaskTemplateStatus: status,
  };
};
